import createCrud from '../crud';

export default createCrud({
    resource: 'sprints',
    parent: 'project'
  });